import { Image, Space } from 'antd';
import { isEmpty, map } from 'lodash';
import moment from 'moment-timezone';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../AppContext';
import { AudioIcon } from '../../../../assets/svg';
import {
  DATETIMEWITHBRACKET,
  GA_EVENT,
  GA_LABEL,
} from '../../../../common/constants';
import { Event } from '../../../../common/trackEvents';
import EllipsisText from '../../../../components/EllipsisText';

const PreviousDetailsCard = ({
  data,
  setAudios = () => {},
  setShowAudioModal = () => {},
  showAudioColumn = true,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [previewImageKey, setPreviewImageKey] = useState('');
  const { getInstructionDetail } = useContext(AppContext);
  const instructionData = getInstructionDetail();
  return data && !isEmpty(data) ? (
    map(data, (details, index) => (
      <div
        className="previous-details-card-wrapper mt-20"
        id={`previous-details-card-${index}`}
      >
        <div id={`previous-details-content-${index}`}>
          <div
            className="d-flex align-center justify-between mb-15"
            id={`previous-details-header-${index}`}
          >
            <div
              className="d-flex"
              id={`previous-details-author-wrapper-${index}`}
            >
              <h5 id={`previous-details-author-${index}`}>
                {`${data?.length - index}. ${
                  details?.rejector?.name ||
                  details?.responderUser?.name ||
                  details?.modifier?.name ||
                  ''
                } - ${
                  details?.createdAt &&
                  moment(details?.createdAt)
                    .tz(instructionData?.project?.timeZone)
                    .format(DATETIMEWITHBRACKET)
                }`}
              </h5>
            </div>
          </div>
          <EllipsisText
            id={`previous-details-remark-${index}`}
            text={details?.remark || '-'}
          />
          <div
            className="d-flex justify-between align-center"
            id={`previous-details-media-container-${index}`}
          >
            {details?.photos?.length > 0 && (
              <Space orientation="vertical" size={12} className="mt-12">
                <div id={`previous-details-images-wrapper-${index}`}>
                  <Image.PreviewGroup
                    id={`previous-details-image-preview-group-${index}`}
                    preview={{
                      open: details?.id === previewImageKey && isVisible,
                      onOpenChange: (visible) => {
                        setIsVisible(visible);
                        if (visible) {
                          Event(GA_EVENT.OPENED_IMAGE_VIEWER, {
                            label: GA_LABEL.OPENED_IMAGE_VIEWER,
                            // eslint-disable-next-line no-undef
                            pathname: window?.location?.href,
                          });
                        }
                      },
                    }}
                  >
                    <Space className="image-preview-wrapper issue-images">
                      {React.Children.map(
                        details?.photos,
                        (photo, photoIndex) => (
                          <Image
                            id={`previous-details-image-${index}-${photoIndex}`}
                            src={photo}
                            alt="logo"
                            height="64px"
                            width="64px"
                            onClick={() => setPreviewImageKey(details?.id)}
                          />
                        ),
                      )}
                      {details?.photos?.length > 1 && (
                        <div
                          id={`previous-details-images-extra-count-${index}`}
                          className="extra-count pointer"
                          onClick={() => {
                            setIsVisible(true);
                            setPreviewImageKey(details?.id);
                          }}
                        >
                          {`+${details?.photos?.length - 1}`}
                        </div>
                      )}
                    </Space>
                  </Image.PreviewGroup>
                </div>
              </Space>
            )}

            {showAudioColumn && details?.audios?.length > 0 && (
              <Space orientation="vertical" size={12} className="mt-12">
                <div id={`previous-details-audio-wrapper-${index}`}>
                  <div
                    id={`previous-details-audio-player-${index}`}
                    className="audio-player-wrapper issue-audio"
                    onClick={() => {
                      setAudios(details?.audios);
                      setShowAudioModal(true);
                      Event(GA_EVENT.DOWNLOAD_AUDIO, {
                        label: GA_LABEL.DOWNLOAD_AUDIO,
                        // eslint-disable-next-line no-undef
                        pathname: window?.location?.href,
                      });
                    }}
                  >
                    <AudioIcon id={`previous-details-audio-icon-${index}`} />
                    {details?.audios?.length > 1 && (
                      <div
                        className="extra-count"
                        id={`previous-details-audio-extra-count-${index}`}
                      >{`+${details?.audios?.length - 1}`}</div>
                    )}
                  </div>
                </div>
              </Space>
            )}
          </div>
        </div>
      </div>
    ))
  ) : (
    <div className="previous-details-card-wrapper mt-20 text-secondary fw-medium">
      No previous details found
    </div>
  );
};

export default PreviousDetailsCard;
